import { render, staticRenderFns } from "./closedMsg.vue?vue&type=template&id=6d8b0bb2"
import script from "./closedMsg.vue?vue&type=script&lang=js"
export * from "./closedMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports